/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import cn from 'clsx';
import { Form } from 'antd';
import { AModal, AButton, ATooltip, AInput, ASelect, ATextarea, ASpin } from 'components/Antd';
import FormItem from 'views/DesktopReview/components/FormItem';
import { ReactComponent as LampIcon } from 'assets/icons/New/lamp-icon.svg';
import { ReactComponent as LoadingSvg } from 'assets/icons/New/loading.svg';
import { ReactComponent as GenerateSvg } from 'assets/icons/New/generate.svg';
import { ReactComponent as AIInsightSvg } from 'assets/icons/New/ai-insight-1.svg';
import { ReactComponent as ViewHistorySvg } from 'assets/icons/New/view-history.svg';
import { BetaTag } from 'views/ProductDetail/Sections/QualityRequirement/components/AIInsight';
import Success from './Success';
import { COUNTRY_OPTIONS, INTEND_OPTIONS } from './constants';
import classes from './AIModal.module.scss';

const AIModal = ({
  open,
  onClose,
  onSubmit,
  onExecute,
  onDownload,
  onCancelSubmit,
  productDetail,
  onChecksChange,
}) => {
  const hideHistory = true;
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [aiData, setAIData] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {}, []);

  return (
    <>
      <AModal
        title={
          <>
            <AIInsightSvg width={24} height={24} />
            <span>AI Insight</span>
            <BetaTag style={{ marginLeft: '-4px' }} />
            {!hideHistory && (
              <ATooltip
                dark
                title="View History"
                placement="top"
                overlayClassName={classes.tooltipOverlay}>
                <span className={classes.viewHistoryBtn}>
                  <ViewHistorySvg />
                </span>
              </ATooltip>
            )}
          </>
        }
        open={open}
        onCancel={onClose}
        closable
        width={1100}
        className={cn(classes.modalWrapper, {
          [classes.isLoading]: loading,
        })}>
        {loading && (
          <ASpin
            container
            className={classes.loadingWrapper}
            indicator={<LoadingSvg className={classes.loadingIcon} />}
          />
        )}
        <Success
          className={cn({
            hide: !isSuccess,
          })}
          onBack={() => {
            setIsSuccess(false);
          }}
          onExport={onDownload}
          onAdd={onExecute}
          form={form}
          data={aiData}
          onChecksChange={onChecksChange}
        />
        <Form
          name="aiForm"
          initialValues={{
            product_name: productDetail?.name || '',
            import_country: null,
            product_intend: null,
            product_description: productDetail?.longDescription || '',
          }}
          onFinish={async (values) => {
            if (onSubmit) setLoading(true);
            setAIData({});
            onSubmit(
              values,
              () => {
                setLoading(false);
              },
              (tData) => {
                setAIData(tData);
                setIsSuccess(true);
              }
            );
          }}
          form={form}
          autoComplete="off"
          layout="vertical"
          className={cn(classes.formWrapper, {
            hide: !!isSuccess,
          })}>
          <div className={classes.formInner}>
            <h2>Fill Information</h2>
            <FormItem label="Product Name" name="product_name" required>
              <AInput
                size="large"
                name="product_name"
                placeholder="Fill here"
                minHeight
                radius="md"
                disabled
              />
            </FormItem>
            <FormItem
              required
              label="Import Country"
              name="import_country"
              rules={[{ required: true, message: 'This field is required!' }]}>
              <ASelect
                allowClear
                showSearch
                placeholder="Select here"
                options={COUNTRY_OPTIONS}
                size="large"
                radius="md"
                virtual
              />
            </FormItem>
            <FormItem
              required
              label="Product Intended Used By"
              name="product_intend"
              rules={[{ required: true, message: 'This field is required!' }]}>
              <ASelect
                allowClear
                showSearch
                placeholder="Select here"
                options={INTEND_OPTIONS}
                size="large"
                radius="md"
                virtual
              />
            </FormItem>
            <div className={classes.descriptionWrapper}>
              <label>
                <span>Product Description & Product Highlight</span>
                <span>*</span>
              </label>
              <div className={classes.caption}>
                <span>
                  <LampIcon />
                </span>
                <span>
                  Providing more detailed information about the product will help our AI generate
                  better results.
                </span>
              </div>
              <FormItem
                required
                name="product_description"
                rules={[{ required: true, message: 'This field is required!' }]}>
                <ATextarea placeholder="Provide a thorough description of your product, covering its purpose, how it operates, the materials used (both external and internal), and any internal components such as rattles, stuffing, or batteries" />
              </FormItem>
            </div>
          </div>
          <div className={classes.footer}>
            {loading ? (
              <AButton
                htmlType="button"
                type="ghost"
                size="large"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setLoading(false);
                  onCancelSubmit();
                }}
                className={classes.backBtn}>
                Back
              </AButton>
            ) : (
              <AButton
                htmlType="submit"
                type="primary"
                size="large"
                icon={<GenerateSvg />}
                className={classes.confirmBtn}
                loading={loading}>
                Generate Insight
              </AButton>
            )}
          </div>
        </Form>
      </AModal>
    </>
  );
};

export default AIModal;
